import 'intersection-observer';
import elementClosest from 'element-closest';

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

elementClosest(window);
